<template>
  <ChatbotAboutLayout
    title="Quantum Career Chatbot"
    what-it-is-subtitle="Navigate your path into quantum"
    :description-paragraphs="descriptionParagraphs"
    :features="features"
    audience-subtitle="For students and early-career professionals"
    :audience-items="audienceItems"
    :resources="resources"
    :video="video"
    cta-text="Ready to try it? Open the live chatbot →"
    cta-route-name="quantumCareerChatbotTab"
  />
</template>

<script>
import ChatbotAboutLayout from "@/components/ChatbotAboutLayout.vue";

export default {
  components: {
    ChatbotAboutLayout,
  },
  setup() {
    const descriptionParagraphs = [
      "Thinking about a career in quantum? This chatbot helps students and early-career professionals explore roles, requirements, and pathways in the quantum field.",
      "Ask in your own words or use suggested prompts — answers are grounded in our own job database of more than 10,000 quantum listings, tailored to your skills, domains, and locations.",
    ];

    const features = [
      {
        title: "From university to the job market",
        text: "Already have technical foundations but unsure how the quantum industry works or what to expect after graduation? Share your background and the chatbot helps bridge that gap.",
      },
      {
        title: "Explore the quantum job market",
        text: "Discover which roles fit you, what employers ask for, and how opportunities differ by sector, domain, and country.",
      },
      {
        title: "Get clear career guidance",
        text: "Receive encouraging, practical answers on skills, requirements, and steps toward your next quantum role.",
      },
    ];

    const audienceItems = [
      {
        title: "Who it's for",
        text: "Students, graduates, and career changers curious about roles in quantum computing, sensing, communication, and related fields.",
      },
      {
        title: "Best use cases",
        text: "Choosing a specialisation, comparing role types, or understanding what employers expect at your career stage.",
      },
      {
        title: "Recurring usefulness",
        text: "Come back as you gain skills, near graduation, or when exploring internships and first roles in quantum.",
      },
    ];

    const resources = [
      {
        label: "Quantum job trends research paper",
        href: "https://arxiv.org/abs/2503.19004",
        description: "Academic background on the global quantum workforce data behind the chatbot.",
      },
    ];

    const video = {
      src: "/videos/quantum-career-chatbot-subtitles.mp4",
      type: "video/mp4",
    };

    return {
      descriptionParagraphs,
      features,
      audienceItems,
      resources,
      video,
    };
  },
};
</script>
